import Catalog from "../components/wizard/Catalog";
import Resume from "../components/wizard/ResumeWizard";
import Applications from "../components/wizard/steps/Applications";
import CurrentType from "../components/wizard/steps/CurrentType";
import SetPoint from "../components/wizard/steps/SetPoint";
import Specs from "../components/wizard/steps/Specs";

const routes = [
    {
        path: "/:locale/applications",
        name: "applications",
        component: Applications
    },
    {
        path: "/:locale/:applications/current-type",
        name: "current-type",
        props: true,
        component: CurrentType
    },
    {
        path: "/:locale/:applications/:currentType/setpoint",
        props: true,
        name: "setpoint",
        component: SetPoint
    },
    {
        path: "/:locale/:applications/:currentType/:setpoint/specs",
        props: true,
        name: "specs",
        component: Specs
    },
    {
        path: "/:locale/final",
        name: "resume",
        component: Resume
    }
];

export default routes;
